import { createScopeFromContext } from 'bunja/react';
import { createContext } from 'react';

export const SubAccountIdContext = createContext<number | undefined>(undefined);
export const SubAccountIdScope = createScopeFromContext(SubAccountIdContext);
